import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
export default function prepareTypographyVars(typography) {
  var vars = {};
  var entries = Object.entries(typography);
  entries.forEach(function (entry) {
    var _entry = _slicedToArray(entry, 2),
        key = _entry[0],
        value = _entry[1];

    if (typeof value === 'object') {
      vars[key] = "".concat(value.fontStyle ? "".concat(value.fontStyle, " ") : '').concat(value.fontVariant ? "".concat(value.fontVariant, " ") : '').concat(value.fontWeight ? "".concat(value.fontWeight, " ") : '').concat(value.fontStretch ? "".concat(value.fontStretch, " ") : '').concat(value.fontSize || '').concat(value.lineHeight ? "/".concat(value.lineHeight, " ") : '').concat(value.fontFamily || '');
    }
  });
  return vars;
}